import { Module } from "@/services/module";

class AutoPaymentCache extends Module {
  constructor() {
    super({});
  }
}
export default new AutoPaymentCache();
